
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8F7A61","opacity":".2","d":"M64 31.874C64 14.284 49.78.02 32.163 0H32.108C14.474.009 0 14.281 0 31.874c0 4.303.858 8.491 2.547 12.453a32.587 32.587 0 0017.127 17.126A31.546 31.546 0 0032.124 64H32.137C49.828 63.992 64 49.415 64 31.874zM3.814 33.75h10.421c.179 3.938.96 7.829 2.3 11.5H7.106a28.165 28.165 0 01-3.292-11.5zm3.222-15.024h9.499a38.906 38.906 0 00-2.287 11.274H3.815a27.824 27.824 0 013.221-11.274zm53.15 11.274H50.002a38.699 38.699 0 00-2.287-11.25h9.277A27.917 27.917 0 0160.187 30zm-13.938 0H34V18.75h9.674A34.48 34.48 0 0146.248 30zM34 15V5.612A34.076 34.076 0 0141.843 15H34zm-3.75-9.39V15h-7.841a34.077 34.077 0 017.841-9.39zm0 13.14V30H18.003a34.48 34.48 0 012.576-11.25h9.671zm-12.26 15h12.26v11.5h-9.671a34.482 34.482 0 01-2.589-11.5zM30.25 49v9.389a34.052 34.052 0 01-7.841-9.389h7.841zM34 58.388v-9.414h7.843A34.178 34.178 0 0134 58.388zm0-13.139V33.724h12.261a34.624 34.624 0 01-2.587 11.525H34zm16.015-11.525h10.171a28.464 28.464 0 01-3.264 11.525h-9.207a38.878 38.878 0 002.3-11.525zM54.611 15h-8.498A37.143 37.143 0 0038.35 4.446C44.947 5.942 50.671 9.764 54.611 15zM25.915 4.43A37.122 37.122 0 0018.138 15h-8.7A28.47 28.47 0 0125.916 4.43zM9.516 48.999h8.621a37.14 37.14 0 007.77 10.561C19.266 58.07 13.5 54.246 9.516 49zM38.36 59.545c3.186-3.026 5.791-6.595 7.752-10.571h8.422c-3.935 5.229-9.623 9.069-16.174 10.571z"}})])
          )
        }
      }
    